
import React , { useState , useEffect  }  from "react";
import { useSelector  } from "react-redux";


import {  useYousign , useContrats} from "../../state/reactquery";
import { queryClient } from '../../state/queryClient';


import { axios_yousign_bulletintoyousign, axios_yousign_bulletinupload } from "../../axios/axios_ficbulletin";

import { modifyoneleadfrontback  } from "../../utils/actions_lead";
import { formatdate } from "../../utils/utils_dates";
import { validtel } from "../../utils/validations";

import Button from "../Buttons/Button";
import Boulettes from "./Boulettes";

import './ContratWinFic.scss' ;
         
const classNames = require('classnames');
function ContratWinContratSend(){
        const lead = useSelector(state=>state.lead.leadactu) ;
        const [etape, setEtape] = useState(0) ;
        const {data: yousign} = useYousign(lead?.id_contrat) ; 
        const {data: contrats} = useContrats(lead?.email,lead?.courtier) ; 
        
        const formule = contrats?.filter(c=>c.id_contrat===lead.id_contrat)?.[0] ;
        
        const [horaire, setHoraire]  = useState(null) ; 
        const [loading, setLoading]  = useState(false) ; 
        const [loadingupload, setLoadingupload]  = useState(false) ; 
        const [alerttelyousign,setAlerttelyousign]  = useState(false) ;


        useEffect(()=>{yousign?.status==='ongoing' && setHoraire(formatdate(yousign?.date_initialisation)) ;
                       yousign?.status==='done' && setHoraire(formatdate(yousign?.date_signature)) ;
                       const newetape =lead?.['sign_bulletin']===0?0:
                                        (lead?.['sign_bulletin']===1 && !yousign?.signature_link) ? 1:
                                        (lead?.['sign_bulletin']===1 && yousign?.signature_link) ? 2:
                                        lead?.['sign_bulletin']===2 ? 3 : 0 ;
                       setEtape(newetape);
        },[yousign?.id,lead?.['sign_bulletin']]);
        
        const textbottom = etape===0?"Signez avec ":etape===1?"Envoyé à ":etape===3?`Signé le ${horaire} avec `:`Envoyé le ${horaire} avec ` ;
        const textbutton = loading?'Envoi en cours':etape===0?"Envoi pour signature":etape===1?"Envoi en cours":etape===2?"Copier le lien de signature":"Signé" ;
        const colorbutton = etape===2?'bouton_backcolor_orangelight':'bouton_color_orange' ;
        const disablebutton = etape===1 || loading  || etape===3; 

        const sendtosignature= async () =>{
                if(etape===0){await sendbulletintoyousign()}
                if(etape===2){navigator.clipboard.writeText(yousign?.signature_link)}
        }



        const sendbulletintoyousign= async () =>{
                if(!validtel(lead.telephone)){ 
                        setAlerttelyousign(true) ;   
                        setTimeout(()=>setAlerttelyousign(false),3000) ;
                        return ;}
                setLoading(true) ;
                await axios_yousign_bulletintoyousign({lead, formule});
                setTimeout(()=>{setLoading(false) ;
                                modifyoneleadfrontback({...lead,'sign_fic':1,'sign_bulletin':1,'statut_client':'attente_signature'}) ;   
                                setHoraire(new Date().toLocaleString('fr-FR')); 
                },1000); 
       }

       const uploaddocument = async () =>{
           setLoadingupload(true) ;
           const response = await axios_yousign_bulletinupload({lead, formule});
           const pdfData= new Blob([response.data], {type:'application/pdf'}) ; 
           const a = document.createElement('a');
           a.href = window.URL.createObjectURL(pdfData);
           a.setAttribute("download", `bulletin_ns${(new Date()).getTime()}.pdf`);
           a.setAttribute('target', '_blank');
           a.click();
           a.remove();
           setTimeout(() => window.URL.revokeObjectURL(a.href), 100) ;
           setLoadingupload(false) ;
       }

        return(<div className='contratwin_box'>
                        <div className='contratwin_box_top'>
                                <div className='contratfic_box_top_texte'>Documents envoyés automatiquement </div>
                                <div className='contratfic_flex_middle1'>
                                        <div className='bulletin_listedoc'>Conditions générales</div>         
                                        <div className='bulletin_listedoc'>Tableau de garantie</div>         
                                        <div className='bulletin_listedoc'>IPID</div>    
                                </div>
                                <div className='contratfic_flex_middle2'>
                                        <div className='bulletin_listedoc'>Bulletin de souscription : </div>
                                        <div className={classNames("contratwinfic_lineformule fontbold")}> 
                                                <span >{formule?.compagnie}</span> <span  >-</span>
                                                <span >{formule?.gamme}</span> <span  >-</span>
                                                <span >{formule?.formule}</span> <span  >-</span>
                                                <span >{formule?.prix} €</span> 
                                        </div>
                                        {formule?.compagnie==='Néoliane' && <div className="errorneoline">
                                                                Attention: Vous devez obligatoirement renseigner le code postal de naissance
                                                                 et la ville de naissance</div> }
                                </div>
            
                        </div>
                        <div className='contratwin_box_bottom'>
                                <div className='contratwin_box_bottom_left'>
                                        <Boulettes total={4} etape={etape} />
                                        <div className='contratwin_box_bottom_message'>{textbottom}</div>
                                </div>
                                <div>
                                {(etape===0 && !loading )&& <Button texte='Télécharger'
                                                                color='bouton_color_orange'
                                                                disable={false}
                                                                loading={loadingupload}
                                                                size='bouton_size_normal'
                                                                onclick={uploaddocument} />}
                                <div className="separatebuttons"></div>
                                <Button texte={textbutton}
                                        color={colorbutton}
                                        disable={disablebutton}
                                        loading={loading}
                                        size='bouton_size_normal'
                                        onclick={sendtosignature} />

                                </div>
                               {alerttelyousign && <div className="errortelyousign">Le format du numéro de téléphone est incorrect.</div>}
                        </div>
                </div>);
}

export default ContratWinContratSend ;

